import { EventsAction } from "Pages/EventsPage/Redux/actions";

export interface IEventsFilter {
  firstDate: Date;
  lastDate: Date;
  city: string;
};

export interface IEvents {
  isFetchingAllEvents: boolean;
  isFetchingFilteredEvents: boolean;
  isFetchAllFailed: boolean;
  isFetchFilteredFailed: boolean;
  isBoxView: boolean;
  isSearchResult: boolean;
  categoryID: number;
  filter: IEventsFilter;
  events: Julius.Website.EventOverviewViewModel[];
  filteredEvents: Julius.Website.EventOverviewViewModel[];
  searchedEvents: Julius.Website.EventOverviewViewModel[];
  maxNumberOfVisible: number;
  eventsIncreaseRatio: number;
};

const initialEvents: IEvents = {
  isFetchingAllEvents: false,
  isFetchingFilteredEvents: false,
  isFetchAllFailed: false,
  isFetchFilteredFailed: false,
  isBoxView: true,
  isSearchResult: false,
  categoryID: 0,
  filter: {
    firstDate: null,
    lastDate: null,
    city: null,
  },
  events: [],
  filteredEvents: [],
  searchedEvents: [],
  maxNumberOfVisible: 12,
  eventsIncreaseRatio: 12,
};

function events(state: IEvents = initialEvents, action: EventsAction): IEvents {
  switch (action.type) {
    case 'SET_ALL_EVENTS':
      return {
        ...state,
        events: action.events,
        isFetchingAllEvents: false,
        isFetchAllFailed: false,
      };

    case 'SET_FILTERED_EVENTS':
      return {
        ...state,
        searchedEvents: [],
        filteredEvents: action.events,
        isFetchingFilteredEvents: false,
      };

    case 'SET_SEARCHED_EVENTS':
      return {
        ...state,
        filteredEvents: [],
        searchedEvents: action.events,
        isFetchingFilteredEvents: false,
      };

    case 'SET_IS_SEARCH_RESULT':
      return {
        ...state,
        isSearchResult: action.isSearchResult,
        categoryID: 0,
      };

    case 'SET_IS_FETCHING_ALL_EVENTS':
      return {
        ...state,
        isFetchingAllEvents: true,
      };

    case 'SET_IS_FETCHING_FILTERED_EVENTS':
      return {
        ...state,
        isFetchingFilteredEvents: true,
      };

    case 'SET_FETCH_ALL_FAILED':
      return {
        ...state,
        isFetchingAllEvents: false,
        isFetchAllFailed: true,
      };

    case 'SET_FETCH_FILTERED_FAILED':
      return {
        ...state,
        isFetchingFilteredEvents: false,
        isFetchFilteredFailed: true,
      };

    case 'ON_BOX_VIEW_CLICK':
      return {
        ...state,
        isBoxView: true,
      };

    case 'ON_LIST_VIEW_CLICK':
      return {
        ...state,
        isBoxView: false,
      };

    case 'ON_MORE_EVENTS_CLICK':
      return {
        ...state,
        maxNumberOfVisible: state.maxNumberOfVisible + state.eventsIncreaseRatio,
      };

    case 'SET_CATEGORY':
      return {
        ...state,
        categoryID: action.id,
        isSearchResult: false,
        maxNumberOfVisible: state.eventsIncreaseRatio,
      };

    case 'SET_FILTER_FIRST_DATE':
      return {
        ...state,
        filter: { ...state.filter, firstDate: action.date },
        maxNumberOfVisible: state.eventsIncreaseRatio,
      };

    case 'SET_FILTER_LAST_DATE':
      return {
        ...state,
        filter: { ...state.filter, lastDate: action.date },
        maxNumberOfVisible: state.eventsIncreaseRatio,
      };

    case 'SET_FILTER_CITY':
      return {
        ...state,
        filter: { ...state.filter, city: action.city },
        maxNumberOfVisible: state.eventsIncreaseRatio,
      };

    case 'SET_FILTER_EMPTY':
      return {
        ...state,
        filter: { ...state.filter, firstDate: null, lastDate: null, city: null },
        filteredEvents: [],
        maxNumberOfVisible: state.eventsIncreaseRatio,
      };

    case 'SET_EVENTS_INCREASE_RATIO':
      return {
        ...state,
        eventsIncreaseRatio: action.ratio,
        maxNumberOfVisible: action.ratio,
      };

    default:
      return state;
  }
};

export default events;


// WEBPACK FOOTER //
// ./src/pages/EventsPage/Redux/reducer.tsx